import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import { getWeekDaysTranslated } from '@enums/week-days-enum';
import { MediaMixin } from '@loandolphin/dolphin-framework';

export default {
  name: 'contact-modal',
  mixins: [MediaMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    uuid: {
      type: String,
      default: null,
    },
    confirmCallback: {
      type: Function,
      required: true,
    },
  },

  data() {
    const startDate = new Date();
    const endDate = new Date();
    startDate.setHours(9, 0, 0);
    endDate.setHours(20, 0, 0);

    return {
      startTime: startDate.toISOString(),
      endTime: endDate.toISOString(),
      selectedWeekDays: [],
      isLoading: false,
      submitError: false,
    };
  },

  computed: {
    ...mapGetters({
      getOfferByUuid: 'connector/getOfferByUuid',
    }),

    weekDaysOptions() {
      return getWeekDaysTranslated(this.$i18n);
    },

    offer() {
      return this.getOfferByUuid(this.uuid);
    },

    providerFirstName() {
      if (isNil(this.offer)) {
        return null;
      }

      return this.offer.fsp.user.first_name;
    },
  },

  methods: {
    toggleModal() {
      this.$emit('update:isOpen', !this.isOpen);
    },

    confirm() {
      this.isLoading = true;
      this.submitError = false;

      return this.confirmCallback(this.selectedWeekDays, this.startTime, this.endTime)
        .then(() => {
          this.isLoading = false;
          this.toggleModal();
        })
        .catch(() => {
          this.isLoading = false;
          this.submitError = true;
        });
    },
  },
};
